import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { compose, getContext, pure } from 'recompose';
import { connect } from 'react-redux';
import { Field } from 'react-final-form';

import { getAddressRefs } from 'selectors';

import { FormBox, FormGroupAdapter, FormFlex, SelectStateAdapter, HideComponentsButton, ShowComponentsButton, HiddenFieldsContainer } from 'components/shared/form';

import { getName, validateRequired } from 'utils';

const propTypes = {
  areComponentsRendered: PropTypes.bool.isRequired,
  setAreComponentsRendered: PropTypes.func.isRequired,
  namespace: PropTypes.string,
  refs: PropTypes.shape({
    statesCollection: PropTypes.arrayOf(PropTypes.object),
  }),
};

const defaultProps = {
  namespace: null,
  refs: {
    statesCollection: [],
  },
};


function AddressFields({ areComponentsRendered, setAreComponentsRendered, namespace, refs }) {
  return (
    <Fragment>
      <FormFlex>
        {areComponentsRendered ? (
          <HideComponentsButton
            namespace={namespace}
            setAreComponentsRendered={setAreComponentsRendered}
          />
        ) : (
          <ShowComponentsButton
            setAreComponentsRendered={setAreComponentsRendered}
            namespace={namespace}
          />
        )}
      </FormFlex>

      <HiddenFieldsContainer isVisible={areComponentsRendered}>
        <FormFlex>
          <FormBox width={[1, 1, 1 / 3]}>
            <Field
              name={getName(namespace, 'streetNumber')}
              required
              label="Street Number"
              validate={validateRequired()}
              component={FormGroupAdapter}
            />
          </FormBox>
          <FormBox width={[1, 1, 1 / 3]}>
            <Field
              name={getName(namespace, 'streetName')}
              required
              label="Street Name"
              validate={validateRequired()}
              component={FormGroupAdapter}
            />
          </FormBox>
          <FormBox width={[1, 1, 1 / 3]}>
            <Field name={getName(namespace, 'premise')} label="Unit/Apt #" component={FormGroupAdapter} />
          </FormBox>
        </FormFlex>

        <FormFlex>
          <FormBox width={[1, 1, 1 / 3]}>
            <Field
              name={getName(namespace, 'municipality')}
              required
              label="City"
              validate={validateRequired()}
              component={FormGroupAdapter}
            />
          </FormBox>
          <FormBox width={[1, 1, 1 / 3]}>
            <Field
              name={getName(namespace, 'stateCode')}
              namespace={namespace}
              required
              type="select"
              options={refs.statesCollection}
              label="State"
              validate={validateRequired()}
              component={SelectStateAdapter}
            />
          </FormBox>
          <FormBox width={[1, 1, 1 / 3]}>
            <Field
              name={getName(namespace, 'postalCode')}
              required
              label="ZIP"
              validate={validateRequired()}
              component={FormGroupAdapter}
            />
          </FormBox>
        </FormFlex>

        <FormFlex>
          <FormBox width={[1, 1, 1 / 3]}>
            <Field name={getName(namespace, 'county')} label="County" component={FormGroupAdapter} />
          </FormBox>
          <FormBox width={[1, 1, 1 / 3]}>
            <Field
              name={getName(namespace, 'countryCode')}
              required
              label="Country Code (US)"
              validate={validateRequired()}
              component={FormGroupAdapter}
            />
          </FormBox>
          <FormBox width={[1, 1, 1 / 3]}>
            <Field
              name={getName(namespace, 'countryName')}
              required
              label="Country Name"
              validate={validateRequired()}
              component={FormGroupAdapter}
            />
          </FormBox>
        </FormFlex>
      </HiddenFieldsContainer>
    </Fragment>
  );
}

AddressFields.propTypes = propTypes;
AddressFields.defaultProps = defaultProps;

function mapStateToProps(state) {
  return {
    refs: getAddressRefs(state),
  };
}

const enhance = compose(
  getContext({
    areComponentsRendered: PropTypes.bool,
    setAreComponentsRendered: PropTypes.func,
    namespace: PropTypes.string,
  }),
  connect(mapStateToProps),
  pure,
);

export default enhance(AddressFields);
